<h1 mat-dialog-title [class.warn-message]="data.warningLevel == 'warn'"><mat-icon
        *ngIf="data.warningLevel == 'warn'">warning</mat-icon>
    <span [innerHTML]="data.textContentAsHTML"></span>
</h1>

<div mat-dialog-actions style="float: right">
    <button mat-button [mat-dialog-close]="true">Valider</button>
</div>